import React from "react";
import { CheckCircle2, AlertTriangle, XCircle } from "lucide-react";

export function StatusBadge({ status }) {
  const map = {
    healthy: {
      cls: "bg-emerald-500/10 text-emerald-300 border-emerald-500/30",
      Icon: CheckCircle2,
      label: "Saludable",
    },
    degraded: {
      cls: "bg-amber-500/10 text-amber-300 border-amber-500/30",
      Icon: AlertTriangle,
      label: "Degradado",
    },
    unhealthy: {
      cls: "bg-red-500/10 text-red-300 border-red-500/30",
      Icon: XCircle,
      label: "No saludable",
    },
  };
  const conf = map[status] || map.unhealthy;
  const { Icon } = conf;
  return (
    <span
      data-testid={`system-status-badge-${status}`}
      className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-full border text-sm font-medium ${conf.cls}`}
    >
      <Icon className="w-4 h-4" />
      {conf.label}
    </span>
  );
}
